"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEditorialTypePropertyOption = exports.isEditorialTypeProperty = exports.editorialTypePropertyDefinition = void 0;
const editorialTypePropertyOptions = [
    'eventReport',
    'contentHighlight',
    'news',
    'POV',
    'teaserTrailer',
    'interview',
    'listicle',
    'contentSeries',
    'eventEditorial',
    'howTo',
    'portrait',
    'liveRecap',
    'other',
];
exports.editorialTypePropertyDefinition = {
    view: {
        label: 'Editorial Content Type',
        hint: 'Select the editorial type of your story so that we can track what content forms perform best.',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'options',
            argument: editorialTypePropertyOptions,
        },
    ],
    type: 'select',
    multiple: true,
    name: 'editorial-type',
};
const isEditorialTypeProperty = (prop) => {
    return prop.name === exports.editorialTypePropertyDefinition.name;
};
exports.isEditorialTypeProperty = isEditorialTypeProperty;
const isEditorialTypePropertyOption = (option) => {
    return editorialTypePropertyOptions.includes(option);
};
exports.isEditorialTypePropertyOption = isEditorialTypePropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWRpdG9yaWFsLXR5cGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9lZGl0b3JpYWwtdHlwZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLDRCQUE0QixHQUFHO0lBQ25DLGFBQWE7SUFDYixrQkFBa0I7SUFDbEIsTUFBTTtJQUNOLEtBQUs7SUFDTCxlQUFlO0lBQ2YsV0FBVztJQUNYLFVBQVU7SUFDVixlQUFlO0lBQ2YsZ0JBQWdCO0lBQ2hCLE9BQU87SUFDUCxVQUFVO0lBQ1YsV0FBVztJQUNYLE9BQU87Q0FDQyxDQUFBO0FBRUcsUUFBQSwrQkFBK0IsR0FBRztJQUM3QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsd0JBQXdCO1FBQy9CLElBQUksRUFBRSwrRkFBK0Y7S0FDdEc7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFLDRCQUE0QjtTQUN2QztLQUNGO0lBQ0QsSUFBSSxFQUFFLFFBQVE7SUFDZCxRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxnQkFBZ0I7Q0FDUyxDQUFBO0FBSTFCLE1BQU0sdUJBQXVCLEdBQUcsQ0FBQyxJQUFrQixFQUFpQyxFQUFFO0lBQzNGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx1Q0FBK0IsQ0FBQyxJQUFJLENBQUE7QUFDM0QsQ0FBQyxDQUFBO0FBRlksUUFBQSx1QkFBdUIsMkJBRW5DO0FBSU0sTUFBTSw2QkFBNkIsR0FBRyxDQUFDLE1BQWMsRUFBeUMsRUFBRTtJQUNyRyxPQUFRLDRCQUFrRCxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQTtBQUM3RSxDQUFDLENBQUE7QUFGWSxRQUFBLDZCQUE2QixpQ0FFekMifQ==